import { isEmpty } from 'bold-ui'
import { CiapCidSugestao } from 'graphql/types.generated'
import { ErrorObject, required } from 'util/validation'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'

import { AvaliacaoFormModel } from '../AvaliacaoForm'

export function validateProblemasCondicoesAdicionarLpc(
  value: SoapState,
  ciapsCidsObrigatoriosAdicionarLPC: CiapCidSugestao[],
  isMedicoOuEnfermeiro: boolean,
  errors: ErrorObject<AvaliacaoFormModel>
): ErrorObject<AvaliacaoFormModel> {
  if (!isEmpty(ciapsCidsObrigatoriosAdicionarLPC)) {
    const problemasECondicoes = [...value.problemasECondicoes, ...value.avaliacao.problemasECondicoes]
    const hasProblemasObrigatoriosAdicionadosLPC = ciapsCidsObrigatoriosAdicionarLPC.every((ciapCid) =>
      problemasECondicoes.some(
        (cadastrado) =>
          cadastrado.incluirNaListaProblemas &&
          ciapCid.ciap?.codigo === cadastrado.ciap?.codigo &&
          ciapCid.cid10?.codigo === cadastrado.cid?.codigo
      )
    )

    if (!hasProblemasObrigatoriosAdicionadosLPC && isMedicoOuEnfermeiro) {
      errors = {
        ...errors,
        hasSubmittedSugestoesDeProblemas: required(value.avaliacao.hasSubmittedSugestoesDeProblemas),
      }
    }
  }

  return errors
}
